<template>
    <div>
        <search-panorama-inusrer-filters
            v-if="displayedSubjectsByType.insurer"
            v-model="insurerFilters"
            :insurers="insurers"
            :annotationOptions="annotationOptions"
            :displayedSubjectsByType="displayedSubjectsByType"
        />
        <search-panorama-rates-filters
            v-if="displayedSubjectsByType.rates"
            v-model="ratesFilters"
            :annotationOptions="annotationOptions"
        />
        <search-panorama-indemnity-filters
            v-if="displayedSubjectsByType.indemnity"
            v-model="indemnityFilters"
            :annotationOptions="annotationOptions"
        />
    </div>
</template>

<script>
import SearchPanoramaInusrerFilters from "./SearchPanoramaInusrerFilters.vue";
import SearchPanoramaRatesFilters from "./SearchPanoramaRatesFilters.vue";
import SearchPanoramaIndemnityFilters from "./SearchPanoramaIndemnityFilters.vue";

export default {
    props: ["value", "apenafs", "insurers", "annotationOptions", "displayedSubjectsByType"],
    components: {
        SearchPanoramaInusrerFilters,
        SearchPanoramaRatesFilters,
        SearchPanoramaIndemnityFilters,
    },
    data() {
        return {
            insurerFilters: this.value.insurerFilters,
            ratesFilters: this.value.ratesFilters,
            indemnityFilters: this.value.indemnityFilters,
        };
    },
    methods: {
        updateFilters() {
            this.$emit("input", {
                insurerFilters: this.insurerFilters,
                ratesFilters: this.ratesFilters,
                indemnityFilters: this.indemnityFilters,
            });
        },
    },
    watch: {
        insurerFilters: {
            handler() {
                this.updateFilters();
            },
            deep: true,
        },
        ratesFilters: {
            handler() {
                this.updateFilters();
            },
            deep: true,
        },
        indemnityFilters: {
            handler() {
                this.updateFilters();
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass"></style>
